import React, { useState } from 'react';
import { Popover } from '@mui/material';
import { Download, X } from 'lucide-react';

const ExportFilenamePopover = ({ 
    children, 
    defaultFilename = "export.xlsx", 
    onExport, 
    buttonText = "Download Excel" 
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [filename, setFilename] = useState(defaultFilename);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setFilename(defaultFilename);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleConfirm = () => {
        const finalName = filename.trim() || defaultFilename;
        // Ensure it ends with the proper extension if not provided
        const ext = defaultFilename.includes('.') ? defaultFilename.split('.').pop() : 'xlsx';
        let exportName = finalName.replace(/\s+/g, '_');
        if (!exportName.toLowerCase().endsWith(`.${ext}`)) {
            exportName = `${exportName}.${ext}`;
        }
        onExport(exportName);
        handleClose();
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <div onClick={handleClick} className="inline-block cursor-pointer">
                {children}
            </div>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e2e8f0',
                        overflow: 'visible',
                        mt: 1
                    }
                }}
            >
                <div className="p-4 w-[280px]">
                    <div className="flex justify-between items-center mb-3">
                        <h3 className="text-sm font-bold text-slate-800">Export As</h3>
                        <button onClick={handleClose} className="text-slate-400 hover:text-slate-600 transition-colors">
                            <X className="w-4 h-4" />
                        </button>
                    </div>
                    
                    <div className="flex flex-col gap-3">
                        <div className="flex flex-col gap-1.5">
                            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Filename</label>
                            <input 
                                type="text" 
                                value={filename}
                                onChange={(e) => setFilename(e.target.value)}
                                className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow"
                                placeholder={defaultFilename}
                                autoFocus
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleConfirm();
                                }}
                            />
                        </div>
                        
                        <button 
                            onClick={handleConfirm}
                            className="w-full flex items-center justify-center gap-2 py-2 bg-blue-600 text-white rounded-lg font-semibold text-sm hover:bg-blue-700 transition-colors shadow-sm mt-1"
                        >
                            <Download size={16} />
                            {buttonText}
                        </button>
                    </div>
                </div>
            </Popover>
        </>
    );
};

export default ExportFilenamePopover;
